import { LngLat, LngLatBounds } from 'maplibre-gl';
export class RouteReport {
  constructor(id, created, creator, computedRouteId, profile, isAlternative, wayPoints, geometry, geometryDrawn, description, status, response, source) {
    this.id = id;
    this.created = created;
    this.creator = creator;
    this.computedRouteId = computedRouteId;
    this.profile = profile;
    this.isAlternative = isAlternative;
    this.wayPoints = wayPoints;
    this.geometry = geometry;
    this.geometryDrawn = geometryDrawn;
    this.description = description;
    this.status = status;
    this.response = response;
    this.source = source;
    const bounds = geometry || geometryDrawn ? new LngLatBounds() : null;
    if (geometry) {
      geometry.coordinates.forEach(([lng, lat]) => bounds?.extend(new LngLat(lng, lat)));
    }
    if (geometryDrawn) {
      this.geometryDrawn.coordinates.forEach(coordinates => {
        coordinates.forEach(([lng, lat]) => bounds?.extend(new LngLat(lng, lat)));
      });
    }
    this.bounds = bounds;
    this.isClosed = this.status === 'CLOSED' || this.status === 'ARCHIVED' || this.status === 'CLOSED_BY_OSM';
  }
  get JOSMParams() {
    if (!this.bounds) return '';
    return `left=${this.bounds.getWest()}&right=${this.bounds.getEast()}&top=${this.bounds.getNorth()}&bottom=${this.bounds.getSouth()}`;
  }
  clone() {
    return new RouteReport(this.id, this.created, this.creator, this.computedRouteId, this.profile, this.isAlternative, this.wayPoints, this.geometry, this.geometryDrawn, this.description, this.status, this.response, this.source);
  }
}